import { useCallback, RefObject } from 'react';
import { CKEditorInstance } from '../types';

export const useEditorActions = (editorRef: RefObject<CKEditorInstance>) => {
  const handleFocus = useCallback(() => {
    const editor = editorRef.current?.editor;
    if (editor) {
      editor.editing.view.focus();
    }
  }, [editorRef]);

  const handleUndo = useCallback(() => {
    const editor = editorRef.current?.editor;

    if (editor) {
      editor.execute('undo');
    }
  }, [editorRef]);

  const handleRedo = useCallback(() => {
    const editor = editorRef.current?.editor;
    if (editor) {
      editor.execute('redo');
    }
  }, [editorRef]);

  const handleBold = useCallback(() => {
    const editor = editorRef.current?.editor;
    if (editor) {
      editor.execute('bold');
    }
  }, [editorRef]);

  const handleItalic = useCallback(() => {
    const editor = editorRef.current?.editor;
    if (editor) {
      editor.execute('italic');
    }
  }, [editorRef]);

  const handleUnderline = useCallback(() => {
    const editor = editorRef.current?.editor;
    if (editor) {
      editor.execute('underline');
    }
  }, [editorRef]);

  const handleBullets = useCallback(() => {
    const editor = editorRef.current?.editor;
    if (editor) {
      editor.execute('bulletedList');
    }
  }, [editorRef]);

  return {
    handleFocus,
    handleUndo,
    handleRedo,
    handleBold,
    handleItalic,
    handleUnderline,
    handleBullets,
  };
};
